import React, { useEffect } from 'react';
import { Title } from '@gerdau/hefesto/Title';
import HeaderTabs from '../Loyalty/HeaderTabs';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { TopBlock } from './styles';
import logoLoyalty from '../../assets/images/loyalty/loyalty_logo.png';
import {
  loadLoyaltyGoal,
  loadLoyaltyHistory
} from '../../store/ducks/loyalty/actions';

const Loyalty: React.FC = () => {
  const user = useSelector((appState: ApplicationState) => appState.user);
  const userState = useSelector((state: ApplicationState) => state.user);
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      !loyalty.goal.loading &&
      !loyalty.goal.error &&
      !loyalty.history.loading &&
      !loyalty.history.error &&
      user.roles.loyaltyCustomers
    ) {
      dispatch(loadLoyaltyHistory(user.roles.loyaltyCustomers));
      dispatch(loadLoyaltyGoal(user.roles.loyaltyCustomers));
    }
  }, [user.userPermissions.hasLoyaltyAccess, loyalty.send_withdraw.loading]);
  return (
    <>
      <TopBlock>
        <div className="title">
          <Title level={1}>{`Olá ${userState.name.split(' ')[0]},`}</Title>
          <p className="subtitle">
            Aqui você encontra todas as informações sobre o programa de
            incentivo
          </p>
        </div>
        <div className="image">
          <img src={logoLoyalty} alt="logo_loyalty" />
        </div>
      </TopBlock>
      <HeaderTabs />
    </>
  );
};

export default Loyalty;
